import { z } from "zod/v4";

// Active User
export const activeUser = z.object({
	userID: z.string().optional(),
	tabID: z.string(),
});
export type ActiveUser = z.infer<typeof activeUser>;
